module.exports = __webpack_public_path__ + "static/img/empty-brand.736b5940.png";